var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"before-after-page__breadcrumbs"},[(_vm.current)?_c('span',{staticClass:"before-after-page__breadcrumbs-current"},[_vm._v(" "+_vm._s(_vm.current)+" ")]):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"before-after-page__breadcrumbs-default"},[_c('span',[_vm._v("BEFORE")]),_c('span',[_vm._v("AFTER")])])
}]

export { render, staticRenderFns }